define('shoptheme/components/tracking',[
	"jquery",
	"cartware/components/_base",
	"cartware/components/Config",
	"cartware/components/PubSubHub",
	"cartware/components/Registry"
], function(
	$,
	Component,
	Config,
	PubSubHub,
	Registry
) {
	var LOGGING_ENABLED = false;
	var TIMEOUT_TRACKING = 250;

	function setAndTrackSubPage() {
		var args = Array.prototype.splice.call(arguments, 0);
		args.unshift(document.location.pathname);
		setAndTrackPage(createSubUrl.apply(this, args));
	}

	function setAndTrackPage(page) {
		if (LOGGING_ENABLED) {
			console.log("setAndTrackPage", page);
		}

		if ("undefined" !== typeof ga) {
			ga('set', 'page', page);
			ga('send', 'pageview');
		}
	}

	// Use this method only for temporary, single pageviews. Otherwise prefer setAndTrackPage.
	// This method will not send the page and therefor not track further data
	// such as events etc. in context of the given page
	function trackPageView(page) {
		return callFunctionWithTimeout(function(hitCallback) {
			if (LOGGING_ENABLED) {
				console.log("trackPageView", page);
			}

			if ("undefined" !== typeof ga) {
				ga('send', 'pageview', page, {
					hitCallback: hitCallback
				});
			}
		});
	}

	function callFunctionWithTimeout(fn, timeout) {
		var deferred = $.Deferred(),
			resolved = false;

		function hitCallback() {
			if (!resolved) {
				resolved = true;
				deferred.resolve();
			}
		}

		fn(hitCallback);

		setTimeout(hitCallback, TIMEOUT_TRACKING);

		return deferred.promise();
	}

	function createSubUrl(pathName) {
		var subPathSegments = Array.prototype.slice.call(arguments, 0);
		var subPath = [];

		pathName = subPathSegments.shift();

		var pathSegments = pathName.split("/");

		for (var i = 0, j = subPathSegments.length; i < j; i++) {
			subPath.push(encodeURIComponent(subPathSegments[i]));
		}

		var suffix = pathName.substr(-1) === "/" ? "/" : "";

		if ("" === suffix) {
			var lastSegment = pathSegments.pop();
			var suffixMatches = /(.*?)(\/|\.[a-zA-Z0-9]+)$/.exec(lastSegment);

			if (suffixMatches) {
				suffix = suffixMatches[2];

				pathSegments.push(suffixMatches[1]);
			}
		}

		return pathSegments.join("/") + "/" + subPath.join("/") + suffix;
	}

	function absoluteToRelativeUrl(absoluteUrl) {
		var baseUrl = Config.get("system.base_url");
		var regex = new RegExp(baseUrl.replace(/https?:\/\//, "https?://").replace(/\/$/, "") + "/");

		return absoluteUrl.replace(regex, "/");
	}

	return Component.create({
		init: function() {
			var self = this;

			Registry().retrieve("featureFlags", function(featureFlags) {
				self.enableLogging(featureFlags.isEnabled("developer_mode") && ("undefined" !== typeof console.log));
			});

			PubSubHub.bind("csp.handsetbase.registration.view", function(data) {
				var basestation = data.basestation;
				var handset = data.handset;

				setAndTrackSubPage(basestation.name, handset.name);
			});

			PubSubHub.bind("csp.compatibility.byproducts.view", function(data) {
				var productNames = [data.productOne.name, data.productTwo.name].sort();

				setAndTrackSubPage(productNames[0], productNames[1]);
			});

			PubSubHub.bind("csp.compatibility.byfeatures.view", function(data) {
				var segments = data.functions;
				Array.prototype.unshift.call(segments, data.product);

				setAndTrackSubPage.apply(this, segments);
			});

			PubSubHub.bind("csp.support.detail.faq.view", function(data) {
				var relativeUrl = absoluteToRelativeUrl(data.faqUrl);
				trackPageView(
					data.product ? createSubUrl(relativeUrl, data.product) : relativeUrl
				).then(function() {
					data.deferred.resolve();
				});
			});
		},

		enableLogging: function(flag) {
			LOGGING_ENABLED = !!flag;
			return this;
		}
	});
});
